import styled from 'styled-components/macro';
export const HolidayListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 14px;
  .view-left {
    background: #fff;
    border-radius: 12px;
    border: 1px solid #e5e5e5;
    overflow: hidden;
    margin-top: 41px;
  }
  .view-total {
    padding: 14px;
    border-bottom: 1px solid #d9d9d9;
  }
  .header-filter {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }
  .description-price {
    color: #808080;
    margin-top: 4px;
  }
  .sub-header-filter {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }
  .view-right-info {
    background: #fff;
    margin-bottom: 20px;
    border: 1px solid #e5e5e5;
    border-radius: 12px;
  }
  .text-flight {
    font-size: 14px;
    font-weight: 600;
    line-height: 2;
  }
  .text-time-flight {
    margin-bottom: 6px;
  }
  .btn-change-flight {
    border: 1px solid #fab317;
    background: #f17922;
    background-image: linear-gradient(to right, #f06f24, #f8b117);
    color: #ffffff;
    border-radius: 8px;
    margin-right: 10px;
    height: 35px;
  }
  .view-box-flight {
    background: #f6f6f6;
    border-radius: 15px;
    padding: 14px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .dot {
    height: 10px;
    width: 10px;
    background-color: #000;
    border-radius: 50%;
  }
  .line {
    height: 2px;
    background-color: #c2c2c2;
    flex: 1;
  }
  .dot-end {
    height: 10px;
    width: 10px;
    background-color: #000;
    border-radius: 50%;
    border: 2px solid #8d8d8d;
  }
  .text-title-info {
    color: #f17922;
    font-weight: 600;
  }
  .boxHeaderFlight {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 12px;
    color: #262626;
  }
  .text-time {
    color: #000;
    font-size: 20px;
    font-weight: 600;
  }
  .view-right-list {
    background: #fff;
    margin-bottom: 10px;
    border: 1px solid #e5e5e5;
    border-radius: 12px;
    padding: 14px;
  }
  .titleGroup {
    font-size: 18px;
    font-weight: 600;
    color: #000;
    margin-bottom: 6px;
  }
  .titleGroupInfo {
    color: #444444;
    font-size: 12px;
    margin-bottom: 12px;
  }
  .combo-img {
    width: 96px;
    height: 96px;
    object-fit: cover;
    border-radius: 8px;
  }
  .item-list {
    margin-left: 14px;
    border-radius: 10px;
    background: #f2f2f2;
  }
  .view-item-left-list {
    background: #fff;
    border-radius: 10px;
    border: 2px solid #f2f2f2;
  }
  .text-price {
    font-size: 22px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .textPriceRange {
    font-size: 14px;
    font-weight: 600;
    color: var(--color-11);
  }
  .boxPriceRange {
    background: #f6f6f6;
    border-radius: 10px;
    padding: 10px;
  }
  .textIncludeCombo {
    color: #999999;
    font-size: 12px;
  }
  .textSeeMoreOtherCombo {
    font-size: 12px;
    color: var(--color-9);
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
`;
export const FilterSearchWrapper = styled.div`
  background: #fff;
  border-radius: 12px;
  margin-bottom: 30px;
  border: 1px solid #e5e5e5;
  .headerSearch {
    border-bottom: 1px solid #d9d9d9;
    padding: 14px;
    display: flex;
    justify-content: space-between;
  }
  .titleSearch {
    font-size: 16px;
    font-weight: 600;
    color: var(--color-11);
    margin-bottom: 6px;
  }
  .subTitleSearch {
    font-size: 14px;
  }
  .boxPoint {
    display: flex;
    flex: 1;
    gap: 10px;
    align-items: center;
    padding-right: 14px;
    cursor: pointer;
  }
  .boxColumnDivider {
    width: 1px;
    height: 100%;
    background-color: #e5e5e5;
    position: relative;
  }
  .boxTrailing {
    position: absolute;
    border: 1px solid #e5e5e5;
    border-radius: 25px;
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    left: -12.5px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
  }
  .contentPopover {
    display: flex;
    flex: 1;
    margin: -10px;
    height: 400px;
    overflow-y: hidden;
  }
  .contentPopoverLeft {
    flex: 1;
    border-right: 2px solid #e5e5e5;
    background: #f2f2f2;
    overflow-y: auto;
  }
  .boxRegion {
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    cursor: pointer;
    .active {
      background-color: #e5e5e5;
    }
    &:hover {
      background-color: #e5e5e5;
    }
  }
  .boxRegion[data-active='true'] {
    background: #e5e5e5;
  }
  .contentPopoverRight {
    flex: 3;
    background-color: '#fff';
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
  .boxAirport {
    padding-top: 9px;
    padding-bottom: 9px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    cursor: pointer;
    &:hover {
      background-color: #e5e5e5;
    }
  }
  .boxAirport[data-active='true'] {
    background: #e5e5e5;
  }
  .boxDate {
    display: flex;
    flex: 1;
    gap: 10px;
    align-items: center;
    padding-right: 14px;
    padding-left: 14px;
  }
  .nightsBadge {
    font-size: 12px;
    color: #444;
    white-space: nowrap;
    padding: 4px 10px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    background: #fafafa;
    flex-shrink: 0;
    margin-left: auto;
    margin-right: 8px;
  }
  .hotelRoomSection {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-right: 10px;
    padding-left: 10px;
    flex-shrink: 0;
  }
  .dataPicker {
    width: 100%;
    background-color: transparent;
    border: none !important;
    padding: 0 !important;
    box-shadow: none !important;
    .ant-picker-input > input {
      ::placeholder {
        font-style: normal;
        color: #999;
        opacity: 1;
      }
    }
  }
  .sub-title {
    font-size: 13px;
    font-weight: 600;
    color: #000;
  }
  .note-title {
    font-size: 11px;
    color: #444444;
  }
  .form-inputNumber {
    background: #f2f2f2;
    width: 100px;
    height: 35px;
    display: flex;
    align-items: center;
    .ant-input-number-input {
      font-size: 14px;
      background: #f2f2f2;
    }
    .ant-input-number-group-addon {
      line-height: 22px;
      background: #f2f2f2;
      i {
        background: #f2f2f2 !important;
      }
    }
    .ant-input-number {
      max-width: 70px;
    }
  }
  .comboTypeBar {
    padding: 10px 14px;
    width: 60%;
    box-sizing: border-box;

    .ant-row {
      display: flex;
      flex-wrap: wrap;
      row-gap: 8px;
      column-gap: 12px;
      margin: 0 !important;
    }

    .ant-col {
      flex: 0 1 auto;
      max-width: 100%;
      padding: 0 !important;
    }
  }
  .stageSelect {
    .ant-select-selector {
      border: none;
      width: 100%;
    }
    .ant-select-selection-item {
      min-width: 90px;
    }
  }
`;
